import { useState } from 'react';
import { useGame } from '../state/gameContext';

export function KickPlayerButton({ playerId }: { playerId: string }) {
  const { currentPlayer, kickPlayer, state } = useGame();
  const [confirm, setConfirm] = useState(false);
  if (!kickPlayer || !currentPlayer?.isHost || playerId === currentPlayer.id) return null;
  const name = state.players.find((p) => p.id === playerId)?.name ?? 'player';
  return confirm ? <div className="flex flex-wrap justify-center gap-2 text-xs mt-2">
    <p className="w-full text-on-surface-variant">Remove {name} from this room?</p>
    <button type="button" className="px-3 py-2 rounded border border-error text-error" data-testid={`confirm-kick-${playerId}`} onClick={() => { kickPlayer(playerId); setConfirm(false); }}>Remove</button>
    <button type="button" className="px-3 py-2 rounded border border-white/20" onClick={() => setConfirm(false)}>Cancel</button>
  </div> : <button type="button" className="text-xs text-error underline underline-offset-4 p-2" aria-label={`Remove ${name}`} data-testid={`kick-${playerId}`} onClick={() => setConfirm(true)}>Remove player</button>;
}

export function RoomManagement() {
  const { state } = useGame();
  return <section className="border-t border-white/10 pt-4">
    <h3 className="text-sm font-bold mb-2">Players at the table</h3>
    <ul className="space-y-3">
      {state.players.map((player) => <li key={player.id} className="flex flex-wrap items-center justify-between gap-2 text-sm">
        <div className="min-w-0 break-words"><span>{player.name}</span>{state.phase !== 'lobby' && <span className="text-primary ml-2">{player.score} pts</span>}<p className="text-xs text-on-surface-variant">{player.isConnected ? 'Connected' : 'Offline · seat saved'}{player.isHost ? ' · Host' : ''}</p></div>
        <KickPlayerButton playerId={player.id} />
      </li>)}
    </ul>
  </section>;
}
